import type { SearchAmbassador } from '@bulknutrients/bulk-shared-lib/interfaces/Ambassador';

import { SearchResultCardAmbassador } from '../SearchResultCardAmbassador';

export function AmbassadorsList({ data }: { data: SearchAmbassador[] }) {
  return (
    <div className="ga-search-list ga-search-ambassadors grid grid-cols-1 gap-10 pb-8 md:grid-cols-2 xl:grid-cols-3">
      {data.map((hit) => (
        <SearchResultCardAmbassador hit={hit} key={hit.name} />
      ))}
    </div>
  );
}
